

































import Global from '@/common/global.js'
import PopupSendMail from '@/views/template/PopupSendMail.vue'
import PopupComfirmDelete from '@/views/template/PopupComfirmDelete.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import Abs from '@/views/molecules/Abs.vue'

export default

  components: {
    PopupSendMail
    PopupComfirmDelete
    BlueButton
    TextBox
    CheckBox
    Abs
  }
  props:
    list:
      type: Array
      default: []
    cancel:
      type: Boolean
      default: true

  watch: {
    list: (v) ->
      @list = v
  }

  data: () ->
    capacityList: Global.capacity()
    status: Global.status()
    mail: Global.mail()
    id: ''
    isShowPopup: {}

  methods: {
    returnCapacity: (capacity) ->
      for row, index in @capacityList
        if capacity == row.id
          return row.name
      return ''
    returnStatus: (num, after_filling) ->
      if num == '1' && after_filling != '0'
        return @status[1].name
      return @status[0].name
    returnMail: (num) ->
      for row, index in @mail
        if row.id == num
          return row.name
      return ''
    containerTypeCheck: (num) ->
      if num != '1'
        return true
      return false
    setId: (id) ->  
      @id = String(id)
    sendMail: () ->
      @$emit('send', @id)
      @closePopup('send_mail')
    rowDelete: () ->
      @$emit('delete', @id)
      @closePopup('delete')
    detail_click: (id) ->
      @$router.push '/admin/plan/detail/' + id
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    back_color: (mailFlag, status, after_filling_flg) ->
      if mailFlag == '1' && status == '1' && after_filling_flg == '1'
        return true
      return false
    change: (v, field) -> 
      @$emit('change', v, field)
  }
